<template>
  <div id="culture" class="culture">
    <div class="items">
      <div
        v-for="(item,index) in lists"
        class="item"
        :class="{'sub-item':index>2}"
        :key="'culture-'+index"
      >
        <div class="bg"></div>
        <div class="info">
          <img :src="item.icon" alt class="logo" />
          <div class="title">{{item.title_ch}}</div>
        </div>
        <div class="detail">
          <p class="title">{{item.title_ch}}</p>
          <p class="content">{{item.remark}}</p>
        </div>
        <img :src="item.background" alt class="img" />
      </div>
    </div>
    <div class="company-culture">
      <h2>企业文化</h2>
      <p class="underline"></p>
      <p class="culture_p">
        Company
        <br />Culture
      </p>
    </div>
  </div>
</template>
<script>
const cultureListUri = "website/index/culture/get/all";

export default {
  data() {
    return {
      lists: []
    };
  },
  created() {
    this.getCultureList();
  },
  methods: {
    getCultureList() {
      this.$api.get(cultureListUri).then(res => {
        // console.log(res)
        this.lists = res.list.slice(0, 5);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.culture {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  align-items: center;
  margin-top: 36px;

  .items {
    flex: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 486px;

    .item {
      width: 246px;
      height: 100%;
      position: relative;
      color: rgba(255, 255, 255, 0.7);

      .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(35, 37, 41, 0.7);
      }

      .info {
        opacity: 1;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.8s ease;
        .logo {
          width: 73px;
          height: 65px;
        }
        .title {
          margin-top: 25px;
        }
      }

      .detail {
        opacity: 0;
        width: 210px;
        position: absolute;
        font-size: 14px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -35%);
        transition: all 0.8s ease;

        .title {
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 12px;
        }
      }

      .img {
        width: 100%;
        height: 100%;
      }

      &:hover {
        .detail {
          opacity: 1;
          transform: translate(-50%, -50%);
        }
        .info {
          opacity: 0;
          transform: translate(-50%, -65%);
        }
      }
    }

    .sub-item {
      height: 50%;
    }
  }

  .company-culture {
    width: 216px;
    min-width: 216px;
    padding: 48px;

    h2 {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    .underline {
      width: 24px;
      height: 2px;
      background: #e60616;
      margin: 36px 0 20px;
    }
    .culture_p {
      font-size: 24px;
      color: #999999;
      line-height: 34px;
    }
  }
}
</style>


